import { IDrillDesignFactor } from '../../interfaces/idrill-design-factor';
import { AssetTeam } from '../asset-team';
import { PhaseStepType } from '../phase-step-type';

export class DrillDesignFactorBase {
  DrillDesignFactorId: number;
  DrillDesignId: number;
  PhaseStepTypeId: number;
  AssetTeamId: number;
  Factor: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;
  PhaseStepType?: PhaseStepType;

  constructor(item?: IDrillDesignFactor) {
    if (item) {

      this.DrillDesignFactorId = item.DrillDesignFactorId;
      this.DrillDesignId = item.DrillDesignId;
      this.PhaseStepTypeId = item.PhaseStepTypeId;
      this.AssetTeamId = item.AssetTeamId;
      this.Factor = item.Factor;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.PhaseStepType = new PhaseStepType(item.PhaseStepType);
    }
  }
}